import { TabItem } from '../../../commonComponents/TabItem';

import '../../../../themes/Button.scss';

export const HYGTabs = ({ value, onValueChanged }) => {
  const tabs = [
    {
      default: true,
      label: 'General',
      value: 'general',
    },
    {
      label: 'Payment',
      value: 'payment',
    },
    {
      label: 'Edits',
      value: 'edits',
    },
    {
      label: 'Jobs',
      value: 'jobs',
    },
    {
      label: 'Offers',
      value: 'offers',
    },
    {
      label: 'Map',
      value: 'mapTab',
    },
    {
      label: 'Notes',
      value: 'notes',
    },
    {
      label: 'Blocked',
      value: 'blocked',
    },
    {
      label: 'Verification',
      value: 'licenses',
    },
    {
      label: 'GoTu Resume',
      value: 'resume',
    },
    {
      label: 'Skills',
      value: 'skills',
    },
    {
      label: 'MedMal',
      value: 'medMalTab',
    },
    {
      label: 'Notifications',
      value: 'notifications',
    },
    {
      label: 'Badges',
      value: 'badges',
    },
    {
      label: 'Favorites',
      value: 'favorites',
    },
    {
      label: 'Feedback',
      value: '#',
      linkedItems: [
        {
          label: 'Reviews',
          value: 'reviewTab',
        },
        {
          label: 'GoTu Feedback',
          value: 'gotu-feedback',
        },
        {
          label: 'NPS',
          value: 'nps',
        },
      ],
    },
    {
      label: 'ProPerks',
      value: '#',
      linkedItems: [
        {
          label: 'Gift Cards',
          value: 'properks-gift-cards',
        },
        {
          label: 'Challenge',
          value: 'properks-challenge',
        },
      ],
    },
    {
      label: 'Promotions',
      value: 'promotions',
    },
    {
      label: 'Campaigns',
      value: 'campaigns',
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        // Wraps rather than running off the edge: HYG carries 17 top-level
        // tabs (18 with the permanent-job-v2 flag on), which no single row
        // fits. `gap` already spaces the wrapped rows, and centring keeps a
        // short trailing row balanced instead of stranded on the left.
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '0.5rem',
        marginBottom: '4px',
        marginTop: '10px',
        position: 'relative',
      }}
    >
      {tabs.map((tab, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <TabItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${tab.value}-${i}`}
          tab={tab}
          value={value}
          onValueChanged={onValueChanged}
        />
      ))}
    </div>
  );
};
